export default __webpack_public_path__ + "static/media/img_participant.5084999c.png";